import(/* webpackMode: "eager" */ "/codebuild/output/src3642150414/src/Hfcl_digital_2.0_web/app/[locale]/error.js");
